import axios from "axios"
import global from "../../../globalvar";

let state = {
    userList: []
};
let getters = {};
let mutations = {
    setUserList(state, userList) {
        state.userList = userList
    }
};
let actions = {
    async loadUsers({commit, dispatch, rootState}) {
        console.log(rootState);
        try {
            commit("appModule/startFetching", null, { root: true });
            let userList = (await axios.get(global.ApiBaseUrl +"/api/user", {
                headers: {
                    "x-auth-token": JSON.parse(localStorage.getItem("authInfo")).token
                }
            })).data;
            commit("appModule/endFetching", null, { root: true })
            commit("setUserList", userList)
        } catch (e) {
            dispatch("appModule/addErrorMessage", e, { root: true } )
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}